export default "__VITE_ASSET__CZFJsnyP__"